// ============================================================================
// todo-client-mod -- 待办事项列表页（公开）
//
// 路径：/todo
// 给访客浏览公开的待办事项列表（按分组/状态过滤）。
// ============================================================================
import * as React from 'react';
import { useTheme } from '../styles/use-theme.js';
import { useResponsive } from '../styles/use-responsive.js';
import { useTodos } from '../hooks/use-todos.js';
import { TodoListItem } from '../components/todo-list-item.js';
import { EmptyIcon } from '../components/icons.js';
import { KEYFRAMES_CSS } from '../styles/animations.js';
import { typography, radius, transition } from '../styles/theme.js';
/**
 * 待办事项列表页 — 公开列表
 */
export function TodoListPage(props) {
    const { initialData } = props;
    const { theme } = useTheme();
    const { isMobile } = useResponsive();
    const { todos, pagination, loading, error, setPage } = useTodos({ pageSize: 20, initialData });
    // 注入全局动画样式
    React.useEffect(() => {
        const styleId = 'todo-list-page-keyframes';
        if (!document.getElementById(styleId)) {
            const style = document.createElement('style');
            style.id = styleId;
            style.textContent = KEYFRAMES_CSS;
            document.head.appendChild(style);
        }
    }, []);
    return React.createElement('div', {
        style: {
            minHeight: '100vh', backgroundColor: theme.bg.primary,
            fontFamily: typography.fontFamily, color: theme.text.primary,
        },
    }, 
    // 页头
    React.createElement('header', {
        style: {
            backgroundColor: theme.bg.secondary,
            borderBottom: `1px solid ${theme.border.divider}`,
            padding: isMobile ? '24px 16px 20px' : '40px 24px 30px',
            textAlign: 'center',
        },
    }, React.createElement('h1', {
        style: {
            margin: '0 0 8px 0',
            fontSize: isMobile ? typography.fontSize['2xl'] : typography.fontSize['3xl'],
            fontWeight: typography.fontWeight.bold, color: theme.text.primary,
        },
    }, '待办事项'), React.createElement('p', {
        style: { margin: 0, fontSize: typography.fontSize.md, color: theme.text.tertiary },
    }, '管理和查看你的所有待办事项')), 
    // 主内容
    React.createElement('main', {
        style: {
            maxWidth: '760px', margin: '0 auto',
            padding: isMobile ? '20px 16px 40px' : '32px 24px 60px',
        },
    }, loading && React.createElement('div', {
        style: { padding: '80px 0', textAlign: 'center', color: theme.text.tertiary, fontSize: typography.fontSize.md },
    }, React.createElement('span', { style: { animation: 'todo-pulse 1.5s ease-in-out infinite', display: 'inline-block' } }, '加载中...')), error && React.createElement('div', {
        style: {
            padding: '16px', backgroundColor: theme.status.dangerBg,
            border: `1px solid ${theme.status.danger}40`, borderRadius: radius.md,
            color: theme.status.danger, fontSize: typography.fontSize.base,
        },
    }, error), !loading && !error && todos.length === 0 && React.createElement('div', {
        style: {
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            padding: '80px 0', gap: '12px', animation: 'todo-fade-in-up 0.3s ease forwards',
        },
    }, React.createElement(EmptyIcon), React.createElement('p', { style: { fontSize: typography.fontSize.lg, color: theme.text.secondary, margin: 0 } }, '暂无待办事项')), !loading && !error && todos.length > 0 && React.createElement('div', {
        style: { display: 'flex', flexDirection: 'column', gap: '6px' },
    }, ...todos.map(todo => React.createElement(TodoListItem, { key: todo._id, todo }))), !loading && pagination && pagination.totalPages > 1 && React.createElement('div', {
        style: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', marginTop: '48px', paddingTop: '24px' },
    }, React.createElement('button', {
        onClick: () => setPage(Math.max(1, pagination.page - 1)), disabled: pagination.page <= 1,
        style: {
            padding: '8px 16px', border: `1px solid ${theme.border.default}`, borderRadius: radius.md,
            backgroundColor: theme.bg.secondary, fontSize: typography.fontSize.base, color: theme.text.secondary,
            cursor: 'pointer', transition: `background-color ${transition.fast}, border-color ${transition.fast}`,
        },
    }, '← 上一页'), React.createElement('span', { style: { fontSize: typography.fontSize.base, color: theme.text.tertiary } }, `${pagination.page} / ${pagination.totalPages}`), React.createElement('button', {
        onClick: () => setPage(Math.min(pagination.totalPages, pagination.page + 1)), disabled: pagination.page >= pagination.totalPages,
        style: {
            padding: '8px 16px', border: `1px solid ${theme.border.default}`, borderRadius: radius.md,
            backgroundColor: theme.bg.secondary, fontSize: typography.fontSize.base, color: theme.text.secondary,
            cursor: 'pointer', transition: `background-color ${transition.fast}, border-color ${transition.fast}`,
        },
    }, '下一页 →'))));
}
//# sourceMappingURL=todo-list-page.js.map